import classnames from 'classnames'
import { FieldValidator } from 'final-form'
import React, { useCallback, useRef } from 'react'
import { Field } from 'react-final-form'
import { useIntl } from 'react-intl'

import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import styles from './Telephone.module.css'

interface ITelephoneProps {
  label?: string
  className?: string
  name: string
  placeholder?: string
  optional?: boolean
  ariaDescription?: string
  type?: 'date' | 'text' | 'number'
  disabled?: boolean,
  dependantValue?: any,
  validate?: FieldValidator<string>,
}

export const Telephone: React.FC<ITelephoneProps> = ({
  type = 'text',
  disabled = false,
  optional = false,
  name,
  label,
  placeholder,
  ariaDescription,
  className = '',
  validate = undefined,
}) => {
  const intl = useIntl()

  const requiredValidation = useCallback((value: string, _allValues: any) => {
    if (!optional && ([undefined, null, '', '+'].includes(value))) {
      return 'Required field'
    } else {
      return undefined
    }
  }, [intl, optional])

  const validatorRef = useRef<FieldValidator<string>>((value: string, allValues: any) => {
    const validations: Array<FieldValidator<string>> = []

    if (!optional) {
      validations.push(requiredValidation)
    }
    if (validate != null) {
      validations.push(validate)
    }

    return validations.reduce((message: string | undefined, fn) => (
      message == null
        ? fn(value, allValues)
        : message
      ), undefined)
  })

  return (
    <Field
      name={name}
      validate={validatorRef.current}
    >
      {({ input, meta }) => (
        <div className={classnames(styles.Telephone, className)}>
          { label && <label htmlFor={name}>{label}</label> }
          <PhoneInput
            defaultCountry="HR"
            id={`id-${name}`}
            className={classnames({
              [styles.NoPadding]: true,
              'form-control': true,
              'is-invalid': meta.touched && meta.error,
            })}
            type={type}
            {...input as any}
            placeholder={placeholder}
            aria-describedby={ariaDescription}
            disabled={disabled}
            international
          />
          { meta.touched && meta.error && <div className='invalid-feedback'>{meta.error}</div> }
          { ariaDescription && (
            <span
              id={`help-${name}`}
              className={classnames('form-text text-muted', styles.AriaDescription)}
            >
              { ariaDescription }
            </span>
          ) }
        </div>
      )}
    </Field>
  )
}
